"use client";

import React from "react";
import { ScanEye, Layers, Activity, Hand, Info, ArrowUpRight } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "Óstios Foliculares",
  description: "Análise microscópica das aberturas dos folículos.",
  details: "Identificação de obstruções, inflamações e padrões de crescimento que indicam a saúde do nascimento do fio.",
  icon: ScanEye,
  colSpan: "md:col-span-1 lg:col-span-2"
}, {
  title: "Epiderme",
  description: "Avaliação da saúde e integridade do couro cabeludo.",
  details: "Detecção de descamações, oleosidade excessiva, psoríase e dermatites que afetam a base capilar.",
  icon: Layers,
  colSpan: "md:col-span-1 lg:col-span-1"
}, {
  title: "Vasos Sanguíneos",
  description: "Mapeamento da vascularização e nutrição.",
  details: "Estudo da microcirculação para garantir que os nutrientes essenciais estejam chegando aos folículos.",
  icon: Activity,
  colSpan: "md:col-span-1 lg:col-span-1"
}, {
  title: "Pull Test",
  description: "Teste de tração e resistência da haste.",
  details: "Avaliação física da fase de queda (telógena/anágena) e da fragilidade da estrutura do fio.",
  icon: Hand,
  colSpan: "md:col-span-1 lg:col-span-2"
}];
export default function OCaminhoDoDiagnostico() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="o-caminho-do-diagnóstico" className="dark bg-background text-foreground relative overflow-hidden py-24 px-4 sm:px-6 lg:px-8 !bg-[url(https://dilsaudecapilar.com.br/wp-content/uploads/2026/02/hair_loss_consultation.webp)]">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559261/img/hair_follicle_blueprint_background.png')] bg-cover bg-center opacity-5 mix-blend-overlay grayscale" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4 text-primary-foreground">
            O Caminho do Diagnóstico
          </h2>
          <p className="text-lg !text-[hsl(0,0%,0%)]">
            Nossa metodologia baseada em 4 pilares fundamentais da tricoscopia para identificar a causa exata e tratar com precisão.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <TooltipProvider delayDuration={100}>
            {pillars.map((pillar, i) => <div key={i} data-index={i} className={`${pillar.colSpan} group`}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="h-full cursor-pointer">
                      <Card className="h-full bg-card/10 backdrop-blur-md border-white/10 hover:bg-card/20 hover:border-primary/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl overflow-hidden relative group-hover:ring-1 group-hover:ring-primary/50">
                        <CardHeader className="relative z-10 pb-2">
                          <div className="flex justify-between items-start">
                            <div className="p-3 rounded-xl bg-primary/10 text-primary mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                              <pillar.icon className="w-8 h-8" />
                            </div>
                            <ArrowUpRight className="w-5 h-5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                          </div>
                          <CardTitle className="text-xl font-semibold text-foreground">
                            {pillar.title}
                          </CardTitle>
                        </CardHeader>
                        <CardContent className="relative z-10">
                          <p className="text-sm leading-relaxed !text-[hsl(0,0%,0%)]">
                            {pillar.description}
                          </p>
                        </CardContent>
                        
                        {}
                        <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-primary/20 blur-3xl rounded-full group-hover:bg-primary/30 transition-all duration-500" />
                      </Card>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side="bottom" className="max-w-xs bg-popover/95 backdrop-blur-xl border-border text-popover-foreground p-4 shadow-2xl">
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center gap-2 font-semibold text-primary">
                        <Info className="w-4 h-4" />
                        <span>Detalhes do Pilar</span>
                      </div>
                      <p className="text-sm leading-relaxed">
                        {pillar.details}
                      </p>
                    </div>
                  </TooltipContent>
                </Tooltip>
              </div>)}
          </TooltipProvider>
        </div>
      </div>
    </section>;
}